import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCategoriesByCountry, getDealersByVicinityId } from '@yme/api';
import { getDealersWithCoordinates, getFilteredDataList, } from '@yme/components/DealerLocator/redux/helpers';
import { getDealerWithCategoriesServices } from '@yme/utils/dealer';
import { FETCH_DEALERS_ACTION_TYPE } from './constants';
export const fetchDealers = createAsyncThunk(FETCH_DEALERS_ACTION_TYPE, async ({ vicinityIds, coordinates, country }) => {
    const [data, categories] = await Promise.all([
        getDealersByVicinityId(vicinityIds, coordinates, country),
        getCategoriesByCountry({
            country,
        }),
    ]);
    const dealers = getDealerWithCategoriesServices(data, categories);
    const payload = coordinates
        ? getFilteredDataList(dealers, coordinates)
        : getDealersWithCoordinates(dealers);
    return payload;
});
